<template>
  <modal :title="title" size="lg" ref="modal">
    <file-viewer class="flex justify-center" :file="file" />
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import Modal from '@/components/modal/Modal.vue';
import { RemoteFile } from '../type';
import FileViewer from './FileViewer.vue';
import { getFileName } from '.';

export default defineComponent({
  mixins: [ModalMixin],
  components: {
    Modal,
    FileViewer,
  },
  props: {
    file: {
      type: Object as () => RemoteFile,
      required: true,
    },
  },
  computed: {
    title(): string {
      return getFileName(this.file) || 'File';
    },
  },
});
</script>
